import React, { useState, useEffect } from "react";
import Content from "../../../components/Content";
import { ServiceGroupDetailsTabs } from "../../../constants/ServiceGroupConstants";
import { ServiceGroupOverviewView } from "./ServiceGroupOverviewView";

export const ServiceGroupDetailsView = () => {
  const [lastTab, setLastTab] = useState(1);

  useEffect(() => {
    let lastTab = JSON.parse(localStorage.getItem("lastTab"));
    if (lastTab) {
      setLastTab(lastTab);
    }
  }, []);

  return (
    <>
      <Content
        tabs={true}
        tabList={ServiceGroupDetailsTabs}
        lastTab={lastTab}
        title={"Tjänstegrupp"}
      >
        <div value={1}>
          <ServiceGroupOverviewView />
        </div>
        <div value={2}></div>
      </Content>
    </>
  );
};
